import tz1 from "@/assets/tz (1).png";
import tz2 from "@/assets/tz (2).png";
import tz3 from "@/assets/tz (3).png";
import tz4 from "@/assets/tz (4).png";
import tz5 from "@/assets/tz (5).png";
import tz6 from "@/assets/tz (6).png";
import {i18n} from "@/lang";

export const conMessage = (messageArray) => {
    try {
        const newTargetMessageArray = []
        // 团队通知
        const teamNotify = i18n.global.t("common.cds33");
        // 账号通知
        const accountNotify = i18n.global.t("common.cds50")
        // 好友邀请
        const friendNotify = i18n.global.t('common.cds32')
        // 公告咨讯
        const announcementNotify = i18n.global.t('common.cds39')

        for (const messageArrayElement of messageArray) {

            const {
                teamName,
                userName,
                customerName,
                subject,
                customerId,
                expirationTime,
                productSort,
                memberTypes
            } = extractData(messageArrayElement['jsonData'])

            // 系统工位/存储空间/营销邮件/智能点数
            const productSortArray = [i18n.global.t('userinfo.vip.work'), i18n.global.t('userinfo.vip.space'), i18n.global.t('userinfo.vip.edm'), i18n.global.t('userinfo.vip.AI')]
            const findTargetProduct = productSortArray[productSort]

            const memberTypesArray = [i18n.global.t('vip.type.1'), i18n.global.t('vip.type.2'), i18n.global.t('vip.type.3')]
            const findTargetMember = memberTypesArray[memberTypes - 5]
            switch (messageArrayElement.messageType * 1) {
                case 1:
                    newTargetMessageArray.push({
                        icon: tz3, titles: teamNotify, innerContent: i18n.global.t("displace_server_team_invite", {
                            username: userName, teamname: teamName
                        }), ...messageArrayElement,
                    })
                    break;
                case 2:
                    newTargetMessageArray.push({
                        icon: tz3, titles: teamNotify, innerContent: i18n.global.t("displace_server_team_agree", {
                            username: userName, teamname: teamName
                        }), ...messageArrayElement,
                    })
                    break;
                case 3:
                    newTargetMessageArray.push({
                        icon: tz3, titles: teamNotify, innerContent: i18n.global.t("displace_server_team_refuse", {
                            username: userName, teamname: teamName
                        }), ...messageArrayElement
                    })
                    break;
                case 4:
                    newTargetMessageArray.push({
                        icon: tz3, titles: teamNotify, innerContent: i18n.global.t("displace_server_team_quit", {
                            username: userName, teamname: teamName
                        }), ...messageArrayElement
                    })
                    break;
                case 5:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("displace_server_team_remove", {teamname: teamName}), ...messageArrayElement
                    })
                    break;
                case 6:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("displace_server_team_disband", {teamname: teamName}), ...messageArrayElement
                    })
                    break;
                case 7:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("common_customer_request_todo_audit", {
                            username: userName,
                            teamname: teamName,
                            name: customerName,
                        }), ...messageArrayElement
                    })
                    break;
                case 8:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("common_customer_request_success_audit", {
                            username: userName,
                            teamname: teamName,
                            name: customerName,
                        }), ...messageArrayElement
                    })
                    break;
                case 9:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("common_customer_request_faild_audit", {
                            username: userName,
                            teamname: teamName,
                            name: customerName,
                        }), ...messageArrayElement
                    })
                    break;
                case 10:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("common_mail_todo_audit", {
                            username: userName, teamname: teamName, subject: subject,
                        }), ...messageArrayElement
                    })
                    break;
                case 11:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("common_mail_success_audit_1", {
                            username: userName, teamname: teamName, subject: subject
                        }), ...messageArrayElement
                    })
                    break;
                case 12:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("common_mail_faild_audit_1", {
                            username: userName, teamname: teamName, subject: subject
                        }), ...messageArrayElement
                    })
                    break;
                case 13:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("common_mail_message_map", {
                            customerName: customerName, teamname: teamName, customerId: customerId,
                        }), ...messageArrayElement
                    })
                    break;
                case 14:
                    newTargetMessageArray.push({
                        icon: tz3,
                        titles: teamNotify,
                        innerContent: i18n.global.t("common_mail_message_delivery_failed", {
                            teamname: teamName, subject: subject
                        }), ...messageArrayElement
                    })
                    break;
                case 15:
                    // 注册完善客户资料
                    newTargetMessageArray.push({
                        icon: tz1,
                        titles: accountNotify,
                        innerContent: i18n.global.t("account.notify.message.new.register"),
                        ...messageArrayElement
                    })
                    break;
                case 16:
                    newTargetMessageArray.push({
                        icon: tz1,
                        titles: accountNotify,
                        innerContent: i18n.global.t("account.notify.message.resource", {
                            expirationTime: expirationTime,
                            productSort: findTargetProduct,
                        }), ...messageArrayElement
                    })
                    break;
                case 17:
                    newTargetMessageArray.push({
                        icon: tz1,
                        titles: accountNotify,
                        innerContent: i18n.global.t("account.notify.message.resource.will", {
                            productSort: findTargetProduct,
                        }), ...messageArrayElement
                    })
                    break;
                case 18:
                    newTargetMessageArray.push({
                        icon: tz1,
                        titles: accountNotify,
                        innerContent: i18n.global.t("account.notify.message.vip", {
                            memberTypes: findTargetMember,
                            expirationTime: expirationTime,
                        }), ...messageArrayElement
                    })
                    break;
                case 19:
                    console.log(19,'ddd')
                    newTargetMessageArray.push({
                        icon: tz1,
                        titles: accountNotify,
                        innerContent: i18n.global.t("account.notify.message.work.order", {
                            memberTypes: findTargetMember,
                        }), ...messageArrayElement
                    })
                    break;

            }
        }

        return newTargetMessageArray;
    } catch (e) {
        console.log(e,'e')
    }
}


function extractData(jsonData) {
    try {
        if (!jsonData) return {};
        const parsed = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
        return {
            teamName: parsed.teamName || "",
            userName: parsed.userName || "",
            customerName: parsed.customerName || "",
            subject: parsed.subject || "",
            customerId: parsed.customerId || "",
            expirationTime: parsed.expirationTime || "",
            productSort: parsed.productSort || "",
            memberTypes: parsed.memberTypes || ""
        };
    } catch (e) {
        console.warn('extractData 解析失败:', e);
        return {};
    }
}